import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { checkImgExists } from "util/checkImgExists";
import { Button } from "@material-ui/core";
import Icon from "components/Icon";

const Card = ({
  book = {},
  BookContentRepository,
  openBook,
  alertShelfDialog,
}) => {
  const [imgExists, setImgExists] = useState(false);
  const imgCover = BookContentRepository.getCoverUrls({ bookId: book.bookId });
  const imgErrorCover = "assets/img/cover.jpg";

  useEffect(() => {
    checkImgExists(imgCover)
      .then(() => {
        setImgExists(true);
      })
      .catch(() => {
        setImgExists(false);
      });
  }, []);

  return (
    <li className={styles["list-item"]}>
      <div
        className={styles["list-img"]}
        onClick={() => openBook(book)}
        style={{
          backgroundImage: `url(${imgExists ? imgCover : imgErrorCover})`,
        }}
      ></div>
      <div className={styles["list-bottom"]}>
        <div className={styles["list-title"]}>{book.displayName}</div>
        <div className={styles["list-tool"]}>
          <div onClick={() => alertShelfDialog(book.bookId, book.id)} className={styles.trash}>
            <Icon name="trashAlt" type="text" className={styles.trash} />
          </div>
          <Button
            className={styles.btn}
            variant="contained"
            startIcon={<Icon name="EnterBook" />}
            onClick={() => openBook(book)}
          >
            進入書本
          </Button>
        </div>
      </div>
    </li>
  );
};
export default Card;
